import { LoadingOverlay } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';

import { STORAGE_KEYS, URLS } from 'consts';
import { useGetUser } from 'entities/user/api';
import { Navigate, Outlet } from 'react-router-dom';

export const ProtectedRouteController = () => {
  const [token] = useLocalStorage({
    key: STORAGE_KEYS.token,
    serialize: value => value,
    getInitialValueInEffect: false,
  });

  const { data, isInitialLoading } = useGetUser({
    enabled: Boolean(token),
  });

  if (isInitialLoading) {
    return <LoadingOverlay visible />;
  }

  if (data) {
    return <Navigate to={URLS.home} replace />;
  }

  return <Outlet />;
};
